import type { ChainArch } from "@opensea/graphql"
import { useCallback } from "react"
import type { OnConnectedCallback } from "../../polychain/hooks"
import { FlowActions } from "../../stores/flowStore"

export type ConnectFlowProps = {
  /**
   * Set a callback that is run after the user has connected their wallet.
   * Callback is not tied to component lifecycle. (as opposed to useConnect hook)
   */
  onConnected?: OnConnectedCallback
  /**
   * Set a callback that is run after the user has authenticated.
   */
  onAuthenticated?: () => void
  /**
   * Whether to automatically switch to the selected wallet after connection.
   * Defaults to true. Set to false to keep the previously connected wallet active.
   */
  switchOnConnect?: boolean
  /*
   * Optional chain architecture to connect to. Defaults to "ALL".
   */
  chainArch?: ChainArch
}

export const useConnectFlow = () => {
  return useCallback(
    ({
      onConnected,
      onAuthenticated,
      switchOnConnect = true,
      chainArch,
    }: ConnectFlowProps = {}) => {
      FlowActions.startFlow({
        type: "connect",
        onConnected,
        onAuthenticated,
        switchOnConnect,
        chainArch,
      })
    },
    [],
  )
}
